
import { FC, useMemo, useState } from 'react'
import './ScenarioTimelineHeader.scss'
import OmniSelect from '../../../../CommonComponents/omni-select/OmniSelect'
import { OrbitStartOptions, TimeFrameOptions } from '../../../../CommonComponents/timeline/constant'
import { OrbitalInsightsIconSvg, OrbitStartOptionTypeSvg, TimeIcon, TimeIntervalSvg } from '../../../../CommonComponents/svgs/Svgs'
import useForm from '../../hooks/useForm'
import { getUtcFormattedDate } from '../../utils/helperFunction'
import CustomToolTip from '../../../../CommonComponents/CustomToolTip'
import ScenarioTimelineController from './ScenarioTimelineController'
import ScenarioLiveTimeIndicator from './ScenarioLiveTimeIndicator'
import useLoader from '../../hooks/useLoader'
import useAssets from '../../hooks/useAssets'
import { OrbitStartOptionsType } from '../../../../CommonComponents/orbital-insights/orbital-insights-type'
import TimelineFilter from '../../../../CommonComponents/timeline/TimelineFilter'
import useTimelineFilter from '../../hooks/useTimelineFilter'
import { isEmpty } from 'lodash'

interface ScenarioTimelineHeaderProps {
    Orbits: string[],
    selectedOrbit: string,
    onOrbitChange: (orbit: string) => void
    selectedFrame: string
    onTimeFrameChange: (frame: string) => void
}

const ScenarioTimelineHeader: FC<ScenarioTimelineHeaderProps> = ({ Orbits, selectedOrbit, onOrbitChange, onTimeFrameChange, selectedFrame }) => {

    const { formData } = useForm()
    const { loading } = useLoader()
    const { schedule, orbitStartOption, setOrbitStartOption } = useAssets()
    const { active, filter, placement, onActiveChange, setSelectedFilter, setSelectedFilterOption } = useTimelineFilter()

    const [openSelect, setOpenSelect] = useState<null | string>(null)

    const simulationStartTime = useMemo(() => formData.schedule?.simulationStartTime || 0, [formData.schedule?.simulationStartTime])
    const simulationDuration = useMemo(() => formData.schedule?.simulationDuration || 0, [formData.schedule?.simulationDuration])
    const generating = useMemo(() => loading.execution === 'Generating', [loading.execution])
    const disabledFilter = useMemo(() => !schedule?.data || isEmpty(schedule?.data), [schedule])

    return (
        <div className='scenario__timeline__header'>
            <div className='scenario__timeline__header__left__container'>
                <span className='scenario__timeline__header__label'>Planning Context</span>
                <div className='scenario__timeline__header__timeDetails__container'>
                    <div className='scenario__timeline__header__time__label'>
                        <CustomToolTip title='Simulation Start Time'>
                            Start
                        </CustomToolTip>
                    </div>
                    <div className='scenario__timeline__header__time__details'>{getUtcFormattedDate(simulationStartTime)}</div>
                    <div className='details__devider' />
                    <div className='scenario__timeline__header__time__label'>
                        <CustomToolTip title='Simulation Duration'>
                            <TimeIcon />
                        </CustomToolTip>
                    </div>
                    <div className='scenario__timeline__header__time__details'>{simulationDuration} min</div>
                </div>
            </div>
            <ScenarioTimelineController />
            <div className='scenario__timeline__header__right__container'>
                <ScenarioLiveTimeIndicator />
                <TimelineFilter
                    active={active}
                    filter={filter}
                    placement={placement}
                    disabled={disabledFilter}
                    onActiveChange={onActiveChange}
                    setSelectedFilter={setSelectedFilter}
                    setSelectedFilterOption={setSelectedFilterOption}
                />
                <div className='scenario__timeframe__details__container'>
                    <div className='timeframe__label'>
                        <CustomToolTip title='Orbit'>
                            <OrbitalInsightsIconSvg />
                        </CustomToolTip>
                    </div>
                    <div className='scenario__omni__select__container'>
                        <OmniSelect
                            id='omni__select__orbit'
                            open={openSelect}
                            setOpen={setOpenSelect}
                            options={Orbits}
                            value={selectedOrbit}
                            onChange={onOrbitChange}
                            disabled={selectedOrbit?.includes('-') || generating}
                            className='omni__select__container'
                            headerOption={{
                                title: 'Orbit',
                                icon: <OrbitalInsightsIconSvg />
                            }}
                        />
                        <div className='scenario__orbitstart__select__container'>
                            <OmniSelect
                                id='omni__select__orbitstart'
                                open={openSelect}
                                setOpen={setOpenSelect}
                                disabled={generating}
                                className='omni__select__container'
                                options={OrbitStartOptions}
                                value={orbitStartOption}
                                onChange={(value) => {
                                    setOrbitStartOption(value as OrbitStartOptionsType)
                                }}
                                hideNavigation
                                icon={<OrbitStartOptionTypeSvg />}
                                headerOption={{
                                    title: 'Orbit Start',
                                    icon: <OrbitStartOptionTypeSvg />
                                }}
                            />
                        </div>
                    </div>
                </div>
                <div className='scenario__timeframe__details__container'>
                    <div className='timeframe__label'>
                        <CustomToolTip title='Timeframe'>
                            <TimeIntervalSvg />
                        </CustomToolTip>
                    </div>
                    <div className='scenario__omni__select__container'>
                        <OmniSelect
                            id='omni__select__timeframe'
                            open={openSelect}
                            setOpen={setOpenSelect}
                            disabled={generating}
                            className='updated__omni__select__border'
                            options={TimeFrameOptions}
                            value={selectedFrame}
                            onChange={onTimeFrameChange}
                            headerOption={{
                                title: 'Timeframe',
                                icon: <TimeIntervalSvg />
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ScenarioTimelineHeader